import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Check if we should skip service worker operations (prevent loop)
const shouldSkipSwOperations = () => {
  const lastSwOp = sessionStorage.getItem('last_sw_operation');
  const now = Date.now();
  if (lastSwOp && (now - parseInt(lastSwOp)) < 10000) { // 10 seconds cooldown
    return true;
  }
  return false;
};

// Register service worker (without force clearing on every load)
if ('serviceWorker' in navigator) {
  // Only do aggressive cleanup once per session
  const hasCleanedUp = sessionStorage.getItem('sw_cleaned_up');
  
  if (!hasCleanedUp && !shouldSkipSwOperations()) {
    sessionStorage.setItem('last_sw_operation', String(Date.now()));
    sessionStorage.setItem('sw_cleaned_up', 'true');
    
    // One-time cleanup for this session
    (async function initialCleanup() {
      try {
        // Clear old caches only (don't unregister SW to prevent loops)
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(name => caches.delete(name)));
          console.log('HELCOO: Cleared old caches');
        }
      } catch (err) {
        console.error('HELCOO: Error clearing caches:', err);
      }
    })();
  }
  
  // Register service worker normally
  serviceWorkerRegistration.register();
}